import { ComponentProps, FC } from 'react';

import { Icon } from '@purpur/library/icon';
import { close } from '@purpur/library/icon/assets/close';

import { Modal } from '@telialt/common-modal/src';
import { DataTest } from '@telialt/utils/src/helpers';

import { CloseButton, ImageModalWrapper } from './ImageModal.styles';

type Props = Pick<ComponentProps<typeof Modal>, 'onHide' | 'isShown'> & {
    imageUrl: string;
} & DataTest;

export const ImageModal: FC<Props> = ({ imageUrl, onHide, isShown, dataTest }) => (
    <ImageModalWrapper
        onHide={onHide}
        isShown={isShown}
        dataTest={dataTest}
        header={
            <CloseButton type="button" onClick={onHide} aria-label="Close">
                <Icon svg={close} size="lg" ally-title="close icon" />
            </CloseButton>
        }
    >
        <img src={imageUrl} alt=" " />
    </ImageModalWrapper>
);
